export const CONTACTS_CATEGORY = "contacts";
export const OBJECTS_CATEGORY = "objects";
export const LEADS_CATEGORY = "leads";
export const EMPLOYEES_CATEGORY = "employees";
